module.exports = __webpack_public_path__ + "img/status-icn_redeemed_coupon@3x.2af4919d.png";